var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "envelope",
    d: "m31,4.64H1c-.2,0-.36.16-.36.36v22c0,.2.16.36.36.36h30c.2,0,.36-.16.36-.36V5c0-.2-.16-.36-.36-.36Zm-.36,21.54l-11-10.08,11-10.27v20.35Zm-14.89-6.92c.14.13.35.13.49,0l2.86-2.67,10.96,10.05H1.93l10.96-10.05,2.86,2.67Zm14.33-13.9l-14.09,13.15L1.91,5.36h28.17Zm-17.72,10.74L1.36,26.18V5.83l11,10.27Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.a1c5417f3d67ffbd08568f0b2c0f2eeb.svg";
export { ForwardRef as ReactComponent };